import { LayoutType, withLayout } from 'hocs/with-layout';
import { withAuth } from 'hocs/auth/with-auth';
import { VaultSettings } from './vault-settings';

const WrapAuth = withAuth(VaultSettings);
// Renders the vault top bar itself, like the other vault screens.
const WrappedVaultSettings = withLayout(LayoutType.Empty, WrapAuth);

export { WrappedVaultSettings as VaultSettings };
